import React, { useContext } from 'react';
import { AppContext } from '../../contexts/global';
import { validateDirectivas, encryptData, modulesAddToken } from '../../utils/utils';
import { trackModuleAccess } from '../../utils/analytics';
import './styles.scss';

export default function EmpleadosSlice({ slice }) {
  const items = slice.items;
  const { user, directivas } = useContext(AppContext);
  const accesosEmpleadosRaw = slice?.primary?.accesos_empleados?.raw;
  const hasModules = items && items.length > 0 && items.some(item => item.link?.url && validateDirectivas(directivas, item.id));
  const changeUrl = (event, url, item) => {
    event.preventDefault();
    trackModuleAccess(item.module || item.id, url);
    const encrypted = encryptData(user["token"]);
    const separator = url.includes('?') ? '&' : '?';
    const newUrl = `${url}${separator}token=${encodeURIComponent(encrypted)}`;
    window.open(newUrl, '_blank');
    return false;
  };

  return (
    <>
      {hasModules && (
        <section className='modules empleados-slice'>
          {accesosEmpleadosRaw && Array.isArray(accesosEmpleadosRaw) && (
            <div className="section-title left">
              {accesosEmpleadosRaw.map((item, index) => (
                <React.Fragment key={index}>
                  {item.type === 'heading5' && <h5>{item.text}</h5>}
                </React.Fragment>
              ))}
            </div>
          )}
          {items.map((item, index) => item.link?.url && validateDirectivas(directivas, item.id) && (
            <a
              id={item.id}
              key={`empleados-${index}`}
              href={item.id === 'modulo.edukando' ? process.env.URL_BASE_EDUKANDO_LABTICA_AUTH : item.link.url}
              rel="noopener noreferrer"
              className='modules-item'
              target='_blank'
              onClick={modulesAddToken.includes(item.id) ? (event) => { return changeUrl(event, item.link.url, item); } : null}
            >
              <div className='modules-item-content'>
                <div
                  className='modules-item-icon'
                  style={{ backgroundColor: item.color }}
                >
                  <em className={`fa-solid fa-${item.icon}`} />
                </div>
                <div className='modules-item-title'>
                  {item.module}
                </div>
              </div>
              <div className='modules-item-actions'>
                Ver más
              </div>
            </a>
          ))}
        </section>
      )}
    </>
  );
}